'use strict';

var _ = require('underscore');

var copyObject = function(object) {
  return JSON.parse(JSON.stringify(object));
};

var deepCopyWithCaseConversion = function(object, keyConverter) {
  if (_.isObject(object)) {
    // construct new object with pascal-cased keys
    var newObject = {};
    var jsonReadyObject = typeof object.toJSON === 'function' ? object.toJSON() : object;
    for (var key in jsonReadyObject) {
      if (!jsonReadyObject.hasOwnProperty(key)) {
        continue;
      }
      var value = jsonReadyObject[key];
      newObject[keyConverter(key)] = deepCopyWithCaseConversion(value, keyConverter);
    }
    return newObject;
  } else if (_.isArray(object)) {
    return object.map(function(val) {
      return deepCopyWithCaseConversion(val, keyConverter);
    });
  }
  // no conversion necessary
  return object;
};

var toPascalCase = function(camelCased) {
  return camelCased.charAt(0).toUpperCase() + camelCased.substring(1);
};

var toCamelCase = function(pascalCased) {
  return pascalCased.charAt(0).toLowerCase() + pascalCased.substring(1);
};

module.exports = {
  deprecated: function(fn, msg, inject_warn) {
    if (!msg) {
      throw new Error('you must supply a message when deprecating a function.');
    }
    return function() {
      (inject_warn || console.warn)(msg);
      return fn.apply(null, arguments);
    };
  },
  // ensure a value is within a min-max range.
  clamp: function(val, min, max) {
    return Math.floor(Math.min(Math.max(val, min), max));
  },
  copyObject: copyObject,
  copyObjectToCamelCase: function(object) {
    return deepCopyWithCaseConversion(object, toCamelCase);
  },
  copyObjectToPascalCase: function(object) {
    return deepCopyWithCaseConversion(object, toPascalCase);
  },
};
